import { useStore } from '@/store'
import './lottery.scss'
import { useLocal } from '@/i18n/LocalContext'
import Sprites from '../Sprites/Sprites'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { closeLoading, loading, rpx } from '@/utils'
import { checkPlayer } from '@/request/utils'
import { play } from '@/request'
import Receive from '../Receive/Receive'
import { clickReport } from '@/report'
import { emitter } from '@/emitter'

interface LotteryProps {
  onLotteryStart?: () => void
  onLotteryEnd?: () => void
}
export default function Lottery(props: LotteryProps) {
  const { onLotteryStart, onLotteryEnd } = Object.assign({}, props)
  const { $t } = useLocal()
  const { state, dispatch } = useStore()
  const tasks = state.tasks
  const allTaskCompleted = tasks.every(
    (item) => item.current === item.total && item.status === 2
  )
  const coupon = state.coupon
  const count = coupon.count
  const isBinded = state.login.userInfo.isBinded
  const playerId = state.login.userInfo.playerId
  const exist = count > 0
  const lotteryText = useMemo(
    () => (
      <span className="lottery__text">
        {!isBinded ? $t('绑定后查看') : exist ? count : $t('暂无抽奖券')}
      </span>
    ),
    [isBinded, exist, count]
  )
  const [backdropVisible, setBackdropVisible] = useState(false)
  const backdropStyle = useMemo(() => {
    if (backdropVisible)
      return {
        display: 'block',
      }

    return {
      display: 'none',
    }
  }, [backdropVisible])
  const [play1, setPlay1] = useState(false)
  const [play2, setPlay2] = useState(false)
  const [playPending, setPlayPending] = useState(false)
  const playResutl = useRef<0 | 1 | 2>(0)
  const pending = useRef(false)
  const [end, setEnd] = useState(true)
  const [modalOpen, setModalOpen] = useState(false)
  const [propList, setPropList] = useState<RewardViewList>([])
  const [boxFramesReady, setBoxFramesReady] = useState(false)
  const bottom = 450
  const boxStyle = useMemo(() => {
    const common = {
      transition: 'bottom 0.4s',
    }

    if (end)
      return {
        display: 'none',
        bottom: rpx(bottom - 80),
        ...common,
      }

    return {
      display: 'block',
      bottom: rpx(bottom),
      ...common,
    }
  }, [end])
  const [effectsFramesReady, setEffectsFramesReady] = useState(false)
  const effectStyle = useMemo(() => {
    const common = {
      bottom: rpx(bottom + 70),
    }

    if (end || !play2)
      return {
        display: 'none',
        ...common,
      }

    return {
      display: 'block',
      ...common,
    }
  }, [end, play2])
  const effectsFrames = 27
  const effectsSrclist = useMemo(() => {
    const size = 10
    const list = []
    for (let i = 1; i <= 3; i++) {
      let n = size * i - 1
      list.push({
        url: `${process.env.BASE_URL_2}assets/sprites/effects${i}_frames.png`,
        frameStart: n - size + 1,
        frameEnd: n > effectsFrames ? effectsFrames : n,
      })
    }
    return list
  }, [])

  useEffect(() => {
    if (!boxFramesReady || !effectsFramesReady) return

    if (window.webLoginLoad$ && window.webLoginLoad$.then instanceof Function) {
      window.webLoginLoad$.then(() => {
        emitter.emit('webLoginLoad')
      })
    } else {
      emitter.emit('webLoginLoad')
    }
  }, [boxFramesReady, effectsFramesReady])

  const closeModal = () => {
    setModalOpen(false)
  }

  const handle = useCallback(async () => {
    clickReport('lottery')
    if (!(await checkPlayer('task'))) return

    if (!exist) {
      if (allTaskCompleted) {
        dispatch({
          type: 'setAlertData',
          data: {
            open: true,
            content: $t('您已完成所有任务并抽奖，敬请期待下次活动~'),
          },
        })
        return
      }
      dispatch({
        type: 'setAlertData',
        data: {
          open: true,
          btnColor: 'blue',
          resolveText: $t('获取'),
          content: $t('抽奖券不足，完成「邀请任务」获得更多抽奖券吧！'),
          onResolve: () => {
            const taskLiseElem =
              document.querySelector<HTMLElement>('.task-list-box')
            const scroller = document.querySelector('.home')
            if (!taskLiseElem || !scroller) return

            const top = taskLiseElem.offsetTop - (50 / 640) * window.innerWidth
            scroller.scrollTo({
              top,
              behavior: 'smooth',
            })
          },
        },
      })
      return
    }

    if (pending.current) return

    const framesNotReady = !boxFramesReady || !effectsFramesReady

    if (framesNotReady) {
      loading()
    } else {
      pending.current = true
    }
    playResutl.current = 0
    setPlayPending(false)
    play(playerId, coupon).then((res) => {
      closeLoading()
      playResutl.current = res.rewardViewList.length ? 1 : 2
      setPlayPending(false)

      if (res.rewardViewList.length) {
        dispatch({
          type: 'play',
          data: res.coupon,
        })
        setPropList(res.rewardViewList)
        if (framesNotReady) {
          setModalOpen(true)
        }
      } else {
        closeModal()
      }
    })

    if (framesNotReady) return

    onLotteryStart instanceof Function && onLotteryStart()
    setEnd(false)
    setBackdropVisible(true)
    setPlay1(true)
    setPlay2(false)
  }, [boxFramesReady, effectsFramesReady, playerId, coupon, allTaskCompleted])

  const handle2 = useCallback(() => {
    setPlay1(false)
    setPlay2(true)
  }, [])

  const onEnd = useCallback(() => {
    pending.current = false
    onLotteryEnd instanceof Function && onLotteryEnd()
    if (playResutl.current < 2) {
      setModalOpen(true)
    }
    setPlay1(false)
    setPlay2(false)
    setBackdropVisible(false)
    setEnd(true)
    if (playResutl.current === 0) {
      setPlayPending(true)
    }
  }, [])

  return (
    <>
      <div key="1" className="lottery">
        {exist ? (
          <i
            className={`lottery__icon lottery__icon--${state.coupon.level}`}
          ></i>
        ) : null}
        {lotteryText}
      </div>
      <div key="2" className="lottery-btn btn-active" onClick={handle}>
        <span>{$t('点击抽奖')}</span>
      </div>
      <div className="lottery-backdrop" style={backdropStyle}></div>
      <Sprites
        key="3"
        src={`${process.env.BASE_URL_2}assets/sprites/img_webp/box_frames.png`}
        corssOrigin={state.canvasCrossOrigin}
        poster={`${process.env.BASE_URL}assets/img_webp/box_poster.png`}
        autoplay={false}
        play={play1}
        width={400}
        height={485}
        frames={20}
        fps={20}
        className="lottery-box"
        style={boxStyle}
        fillMode="forwards"
        onReady={() => setBoxFramesReady(true)}
        onEnd={handle2}
      />
      <Sprites
        key="4"
        src={effectsSrclist}
        corssOrigin={state.canvasCrossOrigin}
        poster={`${process.env.BASE_URL}assets/img_webp/effects_poster.png`}
        autoplay={false}
        play={play2}
        width={640}
        height={825}
        frames={effectsFrames}
        fps={20}
        className="lottery-effects"
        style={effectStyle}
        onReady={() => setEffectsFramesReady(true)}
        onEnd={onEnd}
      />
      <Receive
        open={modalOpen}
        propList={propList}
        onClose={closeModal}
        pending={playPending}
      />
    </>
  )
}
